module.exports = __webpack_public_path__ + "static/media/formal_shirt.856b82ed.svg";